import React from 'react';
import { useLocation } from 'react-router-dom';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import ComingSoonPage from '../../pages/coming-soon';
import MaintenancePage from '../../pages/maintenance';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const { shouldShowMaintenance, shouldShowComingSoon } = useFeatureFlags();

  // Check for maintenance mode first
  if (shouldShowMaintenance()) {
    return <MaintenancePage />;
  }

  // Check for coming soon mode
  if (shouldShowComingSoon(location.pathname)) {
    return <ComingSoonPage />;
  }

  // If no restrictions, render the children
  return <>{children}</>;
};

export default ProtectedRoute;
